var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats6Mono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.396 5.309h-.083c-.42 0-.782.065-1.088.195-.303.13-.552.31-.747.537a2.28 2.28 0 00-.44.8 3.087 3.087 0 00-.116.555 1.827 1.827 0 01.702-.47c.238-.092.498-.138.781-.138.345 0 .645.065.899.195s.464.308.63.533c.169.221.294.475.376.761.084.284.127.58.127.889 0 .342-.053.66-.157.957a2.25 2.25 0 01-.459.772 2.06 2.06 0 01-.727.517 2.393 2.393 0 01-.967.186c-.38 0-.721-.074-1.02-.22a2.243 2.243 0 01-.757-.605 2.762 2.762 0 01-.47-.89 3.468 3.468 0 01-.16-1.064v-.488c0-.54.068-1.05.205-1.528.137-.482.346-.907.63-1.275a2.95 2.95 0 011.098-.864c.446-.212.979-.317 1.597-.317h.146v.962zM8.103 7.726c-.235 0-.448.055-.64.166-.189.11-.342.255-.46.434a1.2 1.2 0 00-.107.212v.389c0 .283.031.534.093.752.062.215.148.395.26.542.113.143.243.252.39.327.146.075.304.112.473.112.176 0 .336-.036.479-.107.143-.075.265-.178.366-.308.1-.13.177-.285.23-.464a2.09 2.09 0 00.078-.586c0-.202-.026-.39-.078-.566a1.416 1.416 0 00-.22-.469 1.01 1.01 0 00-.366-.317 1.024 1.024 0 00-.498-.117z",
    fill: "#fff"
  })));
}
SvgPokerSeats6Mono.displayName = 'PokerSeats6Mono';
export default SvgPokerSeats6Mono;